export default __webpack_public_path__ + "static/media/JNFT.logo.8c59298d.svg";